import { render, staticRenderFns } from "./EinstellungenArtikel.vue?vue&type=template&id=ab30eac8&"
import script from "./EinstellungenArtikel.vue?vue&type=script&lang=js&"
export * from "./EinstellungenArtikel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports